import React from "react";

function UISwitch({ value, onChange, size = "md", disabled = false }) {
  const sizes = {
    sm: { track: "w-8 h-4",   thumb: "w-3 h-3",   translate: "translate-x-4" },
    md: { track: "w-11 h-6",  thumb: "w-5 h-5",   translate: "translate-x-5" },
    lg: { track: "w-14 h-7",  thumb: "w-6 h-6",   translate: "translate-x-7" },
  };
  const s = sizes[size] || sizes.md;

  return (
    <button
      type="button"
      onClick={() => !disabled && onChange(!value)}
      className={`relative inline-flex items-center rounded-full transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-green-400 ${s.track} ${
        value
          ? "bg-green-500"
          : "bg-gray-300"
      } ${disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}`}
    >
      <span className={`inline-block rounded-full bg-white shadow transform transition-transform duration-200 ${s.thumb} ${
        value ? s.translate : "translate-x-0.5"
      }`} />
    </button>
  );
}

export default UISwitch;